import React, { useContext } from 'react';
import { Container, Grid } from 'semantic-ui-react';
import { GatsbyImage } from 'gatsby-plugin-image';
import BackgroundImage from 'gatsby-background-image';
import { convertToBgImage } from 'gbimage-bridge';
import Link from './Link';
import { LargeMonitorContext } from '../context';
import { toSnakeCase } from '../helpers/common';
import { Media, MediaContextProvider } from '../helpers/responsive';

const CtaFullWidthImage = (props) => {
  const { module } = props;
  const { anchorTagLinkText, ctaGroup } = module;
  const { contentGroup, image } = ctaGroup;
  const largeMonitorContext = useContext(LargeMonitorContext);

  return (
    <MediaContextProvider disableDynamicMediaQueries>
      <Media at="mobile">
        <section
          className="cta-full-width-image"
          id={anchorTagLinkText && `${toSnakeCase(anchorTagLinkText)}`}
        >
          {image?.localFile?.childImageSharp && (
            <GatsbyImage
              image={image.localFile.childImageSharp.gatsbyImageData}
              alt={image.altText ? image.altText : ''}
            />
          )}

          <Container className="cta-full-width-image__container">
            <Grid stackable>
              <Grid.Row>
                <Grid.Column width={8}>
                  <div className="cta-full-width-image__callout-box">
                    {contentGroup.heading && (
                      <span className="cta-full-width-image__heading">
                        {contentGroup.heading}
                      </span>
                    )}
                    {contentGroup.subHeading && (
                      <h3 className="cta-full-width-image__sub-heading">
                        {contentGroup.subHeading}
                      </h3>
                    )}
                    {contentGroup.content && (
                      <p className="cta-full-width-image__content">
                        {contentGroup.content}
                      </p>
                    )}
                    {contentGroup.button && (
                      <Link
                        to={
                          contentGroup.button?.link?.url
                            ? contentGroup.button.link.url
                            : null
                        }
                        target={
                          contentGroup.button?.link?.target
                            ? contentGroup.button.link.target
                            : null
                        }
                        className="button button--dark no-decoration cta-full-width-image__button no-decoration"
                      >
                        {contentGroup.button.title}
                      </Link>
                    )}
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </section>
      </Media>
      <Media greaterThanOrEqual="tablet">
        {image && image.localFile && image.localFile.childImageSharp && (
          <section
            className="cta-full-width-image"
            id={anchorTagLinkText && `${toSnakeCase(anchorTagLinkText)}`}
          >
            <BackgroundImage
              Tag="div"
              {...convertToBgImage(
                image.localFile.childImageSharp.gatsbyImageData
              )}
              backgroundColor={`#fff`}
              className="cta-full-width-image__background"
            >
              <Container className="cta-full-width-image__container">
                <Grid>
                  <Grid.Row>
                    {largeMonitorContext && (
                      <Grid.Column width={1}></Grid.Column>
                    )}
                    <Grid.Column width={5}>
                      <div className="cta-full-width-image__callout-box">
                        {contentGroup.heading && (
                          <span className="cta-full-width-image__heading">
                            {contentGroup.heading}
                          </span>
                        )}
                        {contentGroup.subHeading && (
                          <h3 className="cta-full-width-image__sub-heading">
                            {contentGroup.subHeading}
                          </h3>
                        )}
                        {contentGroup.content && (
                          <p className="cta-full-width-image__content">
                            {contentGroup.content}
                          </p>
                        )}
                        {contentGroup.button && (
                          <Link
                            to={
                              contentGroup.button?.link?.url
                                ? contentGroup.button.link.url
                                : null
                            }
                            target={
                              contentGroup.button?.link?.target
                                ? contentGroup.button.link.target
                                : null
                            }
                            className="button button--dark cta-full-width-image__button no-decoration"
                          >
                            {contentGroup.button.title}
                          </Link>
                        )}
                      </div>
                    </Grid.Column>
                    {largeMonitorContext && (
                      <Grid.Column width={1}></Grid.Column>
                    )}
                  </Grid.Row>
                </Grid>
              </Container>
            </BackgroundImage>
          </section>
        )}
      </Media>
    </MediaContextProvider>
  );
};

export default CtaFullWidthImage;
